import React, { Component } from 'react'
import '../js/imagerotator.js'
import { connect } from 'react-redux'
import { showModal } from '../store/actions'
import classNames from 'classnames'
import ZoomButtons from './ZoomButtons'
import { getLocalFilePath, getAssetFilePath } from '../js/getLocalFilePath'

let rotator = null
let rotatorApi = null
let rotatorZoom = 0
let picture;

class Exterior extends Component {
  componentDidMount () {
    if (rotator) {
      return rotator.reload()
    }

    this.createRotator()
    picture = document.querySelector('.three-sixty-render')
  }

  createRotator () {
    rotator = window.WR360.ImageRotator.Create('wr360PlayerId')
    rotator.licenseFileURL = getLocalFilePath('/license.lic')
    rotator.settings.configFileURL = getLocalFilePath(`/${this.props.model}.xml`)
    rotator.settings.graphicsPath = getLocalFilePath('/images')
    rotator.settings.rootPath = getAssetFilePath('/images')
    rotator.settings.googleEventTracking = false
    rotator.settings.responsiveBaseWidth = window.innerWidth
    rotator.settings.responsiveMinHeight = window.innerHeight
    rotator.settings.hideHotspotsOnZoom = true

    window.addEventListener('resize orientationchange', () => {
      rotator.settings.responsiveBaseWidth = window.innerWidth
      rotator.settings.responsiveMinHeight = window.innerHeight
    })

    document.querySelector('.three-sixty-spinner').addEventListener('fullscreenchange', () => {
      rotator.settings.responsiveBaseWidth = window.innerWidth
      rotator.settings.responsiveMinHeight = window.innerHeight
      rotatorApi.updateDimensions()
    })

    rotator.settings.apiReadyCallback = api => {
      rotatorApi = api
      api.hotspots.onActivate(hotspot => {
        const isLeft = hotspot.coordX < (window.innerWidth * 0.6)
        if (!isLeft) {
          hotspot.coordX = hotspot.coordX + (window.innerWidth * 0.4)
        }
        //when a hotspot is clicked, show the modal.
        let element = window.$(`#${hotspot.hotspotHtmlId}`)
        if (element && !element.hasClass('event_added')) {
          element.on('click touchend', () => {
            this.props.showModal(hotspot.hotspotConfig.hotspotInfo.txt)
            rotatorZoom = 1
            // rotatorApi.images.zoom(rotatorZoom, { x: hotspot.coordX, y: 0 })
            this.closerZoom(hotspot)
          })
          element.addClass('event_added')
        }
      })
    }

    rotator.runImageRotator()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.modal && this.props.modal === null) {
      this.resetZoom()
    }

    if (prevProps.model !== this.props.model) {
      rotator.stop()
      setTimeout(() => {
        rotator.delete()
        this.createRotator()
      }, 100)
    }

    if (this.props.fullScreen === 'true') {
      this.onFullscreen()
    }
  }

  zoomOut = () => {
    if (rotatorZoom === 0) return null
    rotatorZoom -= 0.1
    rotatorApi.images.zoom(rotatorZoom)
  }

  zoomIn = () => {
    if (rotatorZoom === 1) return null
    rotatorZoom += 0.1
    rotatorApi.images.zoom(rotatorZoom)
  }

  resetZoom = () => {
    if (rotatorZoom === 0) return null
    rotatorZoom = 0
    rotatorApi.images.zoom(rotatorZoom)
  }

  onFullscreen = () => {
    const isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)

    const docElm = document.querySelector('.three-sixty-spinner')
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen()
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    }
  }

  closerZoom = hotspot => {
    const { coordX, coordY } = hotspot
    const { innerWidth, innerHeight } = window
    const maxX = innerWidth / 6
    let x = (innerWidth - coordX * 2)
    if (x > maxX) x = maxX
    if (x < -maxX) x = -maxX
    picture.style.transform = `scale(1.5) translate(${x}px, 0%)`;
  }

  render () {
    const { visible } = this.props;

    return (
      <div style={{ height: '100vh', width: '100vw' }}>
        <div
          id="wr360PlayerId"
          className={classNames('wr360_player', !visible && 'hidden')}
        >
          <ZoomButtons
            onZoomIn={this.zoomIn}
            onZoomOut={this.zoomOut}
            onReset={this.resetZoom}
            onFullscreen={this.onFullscreen}
          />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: type => dispatch(showModal(type))
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal,
    fullScreen: state.fullScreen,
  }
}

Exterior.defaultProps = {
  visible: false
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Exterior)
